import { render, staticRenderFns } from "./ModelView.vue?vue&type=template&id=a0fb51f4&scoped=true"
import script from "./ModelView.vue?vue&type=script&lang=js"
export * from "./ModelView.vue?vue&type=script&lang=js"
import style0 from "./ModelView.vue?vue&type=style&index=0&id=a0fb51f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fb51f4",
  null
  
)

export default component.exports